import { NotificationsCenterQueryKeys } from "components/NotificationsCenter/queryKeys";
import { typedQueryClient, useTypedQuery } from "hooks";

export const useIsNotificationsCenterOpen = () => useTypedQuery({ queryKey: NotificationsCenterQueryKeys.isNotificationsCenterOpen, initialData: false }).data;
export const toggleNotificationsCenterVisibility = () => typedQueryClient.setQueryData(NotificationsCenterQueryKeys.isNotificationsCenterOpen, prev => !prev);
